export function getEmptyCard() {
    return { learningAreaCount: 1, learningAreaTotal: 1, headline: 'Themenbereich hinzufügen', chapterCount: 0, areaCount: 0, key: new Date().getTime(), points: 0 }
}

